module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "选择收货地址",
      "size": "small",
      "modal-append-to-body": true,
      "close-on-click-modal": false,
      "lock-scroll": false,
      "custom-class": "w780",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.closeCallback
    }
  }, [_c('div', {
    staticClass: "v-com-form",
    staticStyle: {
      "width": "750px"
    }
  }, [_c('el-row', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.AgentAddressList,
      "border": ""
    },
    on: {
      "row-click": _vm.selectAddress
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Address",
      "label": "收货地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Consignee",
      "label": "收货人",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ConsigneeTel",
      "label": "联系方式"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-row', [_c('area-select', {
    ref: "areaSelect",
    attrs: {
      "value": _vm.areaInfo,
      "diabledProv": _vm.diabledProv,
      "diabledCity": _vm.diabledCity,
      "label": "",
      "label-width": "84px",
      "required": "",
      "disabled": _vm.areaDisabled
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "450px"
    },
    attrs: {
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.AddAddress.ConsigneeAdress),
      callback: function($$v) {
        _vm.$set(_vm.AddAddress, "ConsigneeAdress", $$v)
      },
      expression: "AddAddress.ConsigneeAdress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入联系人"
    },
    model: {
      value: (_vm.AddAddress.Consignee),
      callback: function($$v) {
        _vm.$set(_vm.AddAddress, "Consignee", $$v)
      },
      expression: "AddAddress.Consignee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入联系方式"
    },
    model: {
      value: (_vm.AddAddress.ConsigneeTel),
      callback: function($$v) {
        _vm.$set(_vm.AddAddress, "ConsigneeTel", $$v)
      },
      expression: "AddAddress.ConsigneeTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设为默认地址"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.AddAddress.IsDefault),
      callback: function($$v) {
        _vm.$set(_vm.AddAddress, "IsDefault", $$v)
      },
      expression: "AddAddress.IsDefault"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addAddressBtnLoading
    },
    on: {
      "click": _vm.addAddress
    }
  }, [_vm._v("确认添加")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-523ce956!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/operateAddressDialog/index.vue
// module id = 1479
// module chunks = 1